import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
var Slide = styled.div.withConfig({
  displayName: "Slidestyles__Slide",
  componentId: "sc-ge96bi-0"
})(["width:100%;height:0;transition:opacity 0.3s ease;opacity:0;overflow:hidden;&.", "-carousel__slide--active{height:100%;opacity:1;}"], prefix);
var SlideAlign = styled.div.withConfig({
  displayName: "Slidestyles__SlideAlign",
  componentId: "sc-ge96bi-1"
})(["display:flex;align-items:", ";justify-content:", ";width:100%;height:100%;> img{max-width:100%;height:auto;}"], function (props) {
  return props.verticalAlign === 'top' ? 'flex-start' : props.verticalAlign === 'center' ? 'center' : props.verticalAlign === 'bottom' ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.verticalAlign === 'top' ? 'flex-start' : props.verticalAlign === 'center' ? 'center' : props.verticalAlign === 'bottom' ? 'flex-end' : 'flex-start';
});
var SlideContent = styled.div.withConfig({
  displayName: "Slidestyles__SlideContent",
  componentId: "sc-ge96bi-2"
})(["width:100%;height:100%;"]);
export var Styled = {
  Slide: Slide,
  SlideAlign: SlideAlign,
  SlideContent: SlideContent
};